export default __webpack_public_path__ + "static/media/local-activity.d77e62d8.svg";